const labelSettingsActions = {
  FETCH_LABEL_SETTINGS_REQUEST: 'FETCH_LABEL_SETTINGS_REQUEST',
  FETCH_LABEL_SETTINGS_SUCCESS: 'FETCH_LABEL_SETTINGS_SUCCESS',
  SAVE_LABEL_SETTINGS_REQUEST: 'SAVE_LABEL_SETTINGS_REQUEST',
  SAVE_LABEL_SETTINGS_SUCCESS: 'SAVE_LABEL_SETTINGS_SUCCESS',
  SAVE_LABEL_SETTINGS_ERROR: 'SAVE_LABEL_SETTINGS_ERROR',
  SAVING_LABEL_SETTINGS: 'SAVING_LABEL_SETTINGS',
  SET_ACTIVE_PROFILE: 'SET_ACTIVE_PROFILE',
  fetchLabelSettings: () => ({
    type: labelSettingsActions.FETCH_LABEL_SETTINGS_REQUEST,
  }),
  // payload: { profile: 'etiqueta' | 'fita', settings: { widthCm, ... } }
  saveLabelSettings: (profile, settings) => ({
    type: labelSettingsActions.SAVE_LABEL_SETTINGS_REQUEST,
    payload: { profile, settings },
  }),
  setActiveProfile: (profile) => ({
    type: labelSettingsActions.SET_ACTIVE_PROFILE,
    payload: profile,
  }),
};

export default labelSettingsActions;
